<div class="tk-border-gray-2 px-5 py-4 rounded-xl mb-2 break-inside-avoid">
  <div *ngIf="desc else descTemp" class="mb-3 font-semibold">{{desc}}</div>
  <ng-template #descTemp>
    <div class="mb-3">{{'handover.no-description' | translate}}</div>
  </ng-template>
  <div *ngIf="isImagesVisible" class="flex flex-wrap">
    <img
      *ngFor="let image of images"
      [src]="image | secureImage | async"
      (load)="onImageLoaded()"
      (click)="openImage(image)"
      class="w-32 h-22 mt-2 mr-3 rounded-xl cursor-pointer image"
    />
  </div>
</div>
